import axios from 'axios'
import { ENDPOINTS } from '@/config/endpoints'

// Fire LP pixel if we have a request ID
export function fireLpPixel(lpRequestId) {
  if (!lpRequestId) return

  axios.post(ENDPOINTS.LP_PIXEL + lpRequestId).catch(() => {
    console.log('LP pixel fire failed (silent)')
  })
}

// Fire conversion pixels based on affiliate and revenue
export function fireConversionPixels({ affId, revenue, verifiedDebt }) {
  if (revenue < 45) return

  // TikTok pixel for Click Ventures
  if (affId === 'cvtt') {
    if (typeof ttq === 'function') {
      ttq.track('SubmitForm')
    }
  }

  // Facebook Lead event for high debt
  if (typeof fbq === 'function' && Number(verifiedDebt) >= 15000) {
    fbq('track', 'Lead')
  }
}

// Fire Facebook CompleteRegistration event
export function fireFbCompleteRegistration() {
  if (typeof fbq === 'function') {
    fbq('track', 'CompleteRegistration')
  }
}

// Fire gtag address event
export function fireGtagAddress() {
  if (typeof gtag === 'function') {
    gtag('event', 'address')
  }
}

// Initialize TrustedForm script
export function initTrustedForm() {
  const field = 'xxTrustedFormCertUrl'
  const provideReferrer = false
  const invertFieldSensitivity = false

  const tf = document.createElement('script')
  tf.type = 'text/javascript'
  tf.async = true
  tf.defer = true
  tf.src = 'https://api.trustedform.com/trustedform.js?provide_referrer=' + escape(provideReferrer) +
    '&field=' + escape(field) + '&l=' + new Date().getTime() + Math.random() +
    '&invert_field_sensitivity=' + invertFieldSensitivity

  console.log('TrustedForm: Loading script from', tf.src)

  const s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(tf, s)

  console.log('TrustedForm: Script inserted into DOM')
}

// Initialize Meta/Facebook pixel
export function initMetaPixel(additionalPixelId = null) {
  !function(f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

  fbq('init', '8743882179013171')

  if (additionalPixelId) {
    fbq('init', additionalPixelId)
  }

  fbq('track', 'PageView')
}

// Initialize TikTok pixel
export function initTikTokPixel(pixelId) {
  !function(w, d, t) {
    w.TiktokAnalyticsObject = t
    var ttq = w[t] = w[t] || []
    ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent']
    ttq.setAndDefer = function(t, e) {
      t[e] = function() { t.push([e].concat(Array.prototype.slice.call(arguments, 0))) }
    }
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i])
    ttq.instance = function(t) {
      for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n])
      return e
    }
    ttq.load = function(e, n) {
      var r = 'https://analytics.tiktok.com/i18n/pixel/events.js'
      var o = n && n.partner
      ttq._i = ttq._i || {}
      ttq._i[e] = []
      ttq._i[e]._u = r
      ttq._t = ttq._t || {}
      ttq._t[e] = +new Date
      ttq._o = ttq._o || {}
      ttq._o[e] = n || {}
      n = document.createElement('script')
      n.type = 'text/javascript'
      n.async = !0
      n.src = r + '?sdkid=' + e + '&lib=' + t
      e = document.getElementsByTagName('script')[0]
      e.parentNode.insertBefore(n, e)
    }
  }(window, document, 'ttq')

  ttq.load(pixelId)
  ttq.page()
}

export const pixelService = {
  fireLpPixel,
  fireConversionPixels,
  fireFbCompleteRegistration,
  fireGtagAddress,
  initTrustedForm,
  initMetaPixel,
  initTikTokPixel
}
